import { Button, Typography, Modal } from '@octanner/prism-core'
import { tannerGray } from '@octanner/prism-core/ThemeProvider/colors'
import React from 'react'

type Props = {
  open: boolean
  onClose: () => void
  handleBackToProgram: () => void
  handleGoToSchedule: () => void
  error: string | null
  successMessage: string
  manageCelebrationLDFlag?: boolean
}

export const ResultModal = ({
  open,
  onClose,
  handleBackToProgram,
  handleGoToSchedule,
  error,
  successMessage,
  manageCelebrationLDFlag,
}: Props) => (
  <Modal
    id="create-celebration-result-modal"
    open={open}
    title=""
    actions={
      !error ? (
        <>
          {manageCelebrationLDFlag ? (
            <>
              <Button color="secondary" onClick={handleBackToProgram}>
                Back to program
              </Button>
              <Button color="primary" onClick={handleGoToSchedule}>
                View schedule
              </Button>
            </>
          ) : (
            <>
              <Button color="secondary" onClick={handleBackToProgram}>
                Close
              </Button>
            </>
          )}
        </>
      ) : (
        <Button color="secondary" onClick={onClose}>
          Close
        </Button>
      )
    }
    onClose={onClose}
  >
    <Typography variant="h2" textAlign={'center'} color={tannerGray[900]}>
      {error?.length > 0 ? 'System error' : 'Successfully created celebration'}
    </Typography>

    <Typography sx={{ px: '16px', py: '8px' }} textAlign="center">
      {error?.length > 0
        ? 'Unfortunately, we were unable to create this celebration at this time. Please try again later.'
        : successMessage}
    </Typography>
  </Modal>
)
